import { render, staticRenderFns } from "./NewItemAppFooter.vue?vue&type=template&id=ec91f22a&scoped=true&"
import script from "./NewItemAppFooter.vue?vue&type=script&lang=js&"
export * from "./NewItemAppFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec91f22a",
  null
  
)

export default component.exports